import {
  useState,
  useCallback,
  type PropsWithChildren,
  useEffect,
} from "react";
import { Snackbar } from "@mui/material";
import { SnackbarContext } from "./SnackbarContext";
import { type SnackbarMessage } from "../../types/types";

export const SnackbarProvider = ({ children }: PropsWithChildren) => {
  const [snackbar, setSnackbar] = useState<SnackbarMessage | null>(null);

  const handleClose = useCallback(() => {
    setSnackbar(null);
  }, []);

  useEffect(() => {
    const handleNewMessage: WindowEventHandler<"snackbarmessageopen"> = (
      event,
    ) => {
      setSnackbar(event.detail);
    };

    window.addEventListener("snackbarmessageopen", handleNewMessage);

    return () => {
      window.removeEventListener("snackbarmessageopen", handleNewMessage);
    };
  }, []);

  return (
    <SnackbarContext.Provider value={setSnackbar}>
      {children}
      <Snackbar
        open={!!snackbar}
        autoHideDuration={3000}
        message={snackbar?.content}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        sx={{
          bottom:
            "calc(env(safe-area-inset-bottom) + var(--footer-height) + (var(--spacing) * 4))",
        }}
      />
    </SnackbarContext.Provider>
  );
};
